import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    mandatoryStartTime: String,
    mandatoryEndTime: String,
  };

  static targets = [
    'lunchInput',
    'noChangeRadio',
    'timeStartWrapper',
    'timeEndWrapper',
    'lunchWrapper',
    'lunchWarning',
  ];

  connect() {
    this.defaultTimeRanges = {
      start: this.parseSelectValues(
        this.timeStartWrapperTargets,
        'timeStartSelect'
      ),
      end: this.parseSelectValues(this.timeEndWrapperTargets, 'timeEndSelect'),
    };

    this.setupListenerOnLunchInput();
    $(this.element).on('fields_removed.nested_form_fields', () => {
      this.toggleWarning();
    });

    // wait for all lunch radio buttons to be loaded(duration is not important)
    setTimeout(() => this.toggleWarning(), 10);
  }

  setupListenerOnLunchInput() {
    this.lunchLabels = this.lunchWrapperTarget.querySelectorAll(
      '.radio_button > label'
    );

    this.lunchLabels.forEach((label) => {
      label.addEventListener('click', () => {
        // wait for the change event to finish before toggling the warning
        setTimeout(() => {
          this.toggleWarning();
        }, 10);
      });
    });
  }

  toggleWarning() {
    this.lunchWarningTarget.classList.toggle('d-none', !this.mandatoryLunch());
  }

  mandatoryLunch() {
    // used to display the mandatory lunch message if no lunch is selected
    const checkedInput = this.lunchInputTargets.find((t) =>
      t.closest('.checked')
    );
    if (!checkedInput || checkedInput.value !== 'on') {
      return false;
    }

    let ranges;

    if (this.noChangeRadioTarget.checked) {
      if (this.defaultTimeRanges.start.length === 0) {
        return false;
      }

      ranges = this.defaultTimeRanges;
    } else {
      ranges = {
        start: this.parseSelectValues(
          this.timeStartWrapperTargets.filter(
            (t) => t.closest('fieldset').style.display !== 'none'
          ),
          'timeStartSelect'
        ),
        end: this.parseSelectValues(
          this.timeEndWrapperTargets.filter(
            (t) => t.closest('fieldset').style.display !== 'none'
          ),
          'timeEndSelect'
        ),
      };
    }

    return ranges.start.some((start, index) => {
      return (
        start < this.mandatoryEndTimeValue &&
        ranges.end[index] > this.mandatoryStartTimeValue
      );
    });
  }

  parseSelectValues(wrappers, selectTarget) {
    return wrappers.map((wrapper) => {
      const startTargets = [
        ...wrapper.querySelectorAll(
          `.${selectTarget}`
        ),
      ];
      return startTargets.map((target) => target.value).join(' ');
    });
  }
}
